import React from "react";
import { MenuItem, Select, FormControl, Box, Typography } from "@mui/material";
import { useStyles } from "./style";
import { DropdownIcon } from "./icons";

interface DropdownFilterProps {
  label: string;
  options: string[];
  selected: string;
  onSelect: (option: string) => void;
}

export const DropdownFilter: React.FC<DropdownFilterProps> = ({
  label,
  options,
  selected,
  onSelect,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const longSelected = selected.length > 13;
  const displayText = longSelected ? selected.slice(0, 13) + "..." : selected;
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <FormControl
      variant="outlined"
      size="small"
      className={classes.formControl}
    >
      <Select
        className={classes.select}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        value={displayText}
        onChange={(e) => onSelect(e.target.value)}
        IconComponent={() => null}
        renderValue={(value) => (
          <Box className={classes.upperLabelContainer}>
            <Typography variant="body2" className={classes.upperLabel}>
              {label}
            </Typography>
            <Box className={classes.lowerLabelContainer}>
              <Typography variant="body1" className={classes.lowerLabel}>
                {value || "—"}
              </Typography>
              <Box
                component="span"
                className={classes.icon}
                style={{ marginLeft: longSelected ? "-3px" : "0" }}
              >
                <DropdownIcon width={24} height={24} />
              </Box>
            </Box>
          </Box>
        )}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "white",
              "& .MuiMenuItem-root": {
                backgroundColor: "white !important",
                "&:hover": {
                  backgroundColor: "#f5f5f5 !important",
                },
                "&.Mui-selected": {
                  backgroundColor: "white !important",
                  "&:hover": {
                    backgroundColor: "#f5f5f5 !important",
                  },
                },
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem className={classes.menuItem} key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
